<template>
    <div id='alertcontainer'>
        <v-alert v-for="alert in systemAlerts" :type="alert.type" :key="alert.key" dense rounded dismissable >
            {{alert.message}}
        </v-alert>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    computed: {
       ...mapState(["currentUser", "systemAlerts", "now"])
    }

}
</script>

<style scoped>
#alertcontainer {
    position: sticky;
    top: 12px;
    z-index: 10;
    width: 60%;
    max-width: 600px;
}
</style>